import React from "react";
import { SearchResult } from "./SearchResult";
import {Form} from 'react-bootstrap';
import {ListGroup} from 'react-bootstrap';

export const SearchResultsList = ({ results, setInputValue }) => {
  return (
    <ListGroup style={{ position: "relative" , maxHeight: '150px', overflowY: 'scroll'}}>
     
      {results.map((result, id) => {
        return <SearchResult  result={result} key={id} setInputValue={setInputValue}
        />
      })}
    </ListGroup >
  );
};

 {/*  <Select2 className="custom-select" type="text" value='fff'
                        data={[
                          { text: 'Breakfast', id: 1 },
                          { text: 'Lunch', id: 2 },
                          { text: 'Dinner', id: 3 },
                          { text: 'Cafés', id: 4 },
                          { text: 'Delivery', id: 5 }
                        ]}
                        options={{
                          placeholder: 'Quick Searches', type: "text"
                        }}
                      />
 */}